import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_input, {
      "model-value": _ctx.value,
      disable: _ctx.isLoading,
      debounce: "1000",
      dense: "",
      outlined: "",
      "input-class": "text-center",
      type: "number",
      min: "0",
      style: {"width":"100px"},
      "onUpdate:modelValue": _ctx.onInputChange
    }, {
      append: _withCtx(() => [
        _createVNode(_component_q_btn, {
          icon: "fa fa-plus",
          loading: _ctx.isLoading,
          disable: _ctx.isLoading,
          flat: "",
          dense: "",
          round: "",
          size: "xs",
          color: "primary",
          onClick: _ctx.increment
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode("Add 1 free trial")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "disable", "onClick"])
      ]),
      _: 1
    }, 8, ["model-value", "disable", "onUpdate:modelValue"])
  ]))
}